import React from 'react';
import { buttonVariants, designTokens } from 'utils/designSystem';

const Button = ({ 
  variant = 'primary', 
  children, 
  onClick, 
  icon, 
  style = {},
  ...props 
}) => {
  const getHoverColor = (variant) => {
    const hoverMap = {
      primary: designTokens.colors.primaryHover,
      success: designTokens.colors.successHover,
      danger: designTokens.colors.dangerHover,
      secondary: designTokens.colors.secondaryHover
    };
    return hoverMap[variant];
  };

  return (
    <button
      style={{
        ...buttonVariants[variant],
        ...style
      }}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = getHoverColor(variant);
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = buttonVariants[variant].backgroundColor;
      }}
      {...props}
    >
      {icon && icon}
      {children}
    </button>
  );
};

export default Button;